/* eslint-disable react-hooks/exhaustive-deps */
import HandlerCheckbox from "components/CustomCheckbox/CustomCheckbox";
import DialogAlert from "components/DialogAlert/v2";
import { Column, ParagraphSection, SubtitleSection } from "components/styles";
import { Container, Footer } from "./styles";
import CustomButton from "components/CustomButton/CustomButton";
import useNewAvailableActivityIds from "./utils/hooks/useNewAvailableActivityIds";

const AvailableActivitiesFieldModal = ({
	dialog, universityActivityListSegmented,
	form
}) => {
	const newAvailableActivityIds = useNewAvailableActivityIds({
		dialog, form: form.value
	});
	function saveChanges() {
		form.setAvailableActivities(newAvailableActivityIds.value);
		dialog.hide();
	}
	function getCheckboxProps({ id, name }) {
		const checked = newAvailableActivityIds.exists(id);
		return {
			value: id, label: name,
			checked
		};
	}
	return (
		<DialogAlert dialog={dialog} zIndex={2001}>
			<Container>
				<SubtitleSection>Actividades disponibles</SubtitleSection>
				<ParagraphSection>
					Selecciona la(s) actividad(es) que pueden realizarse en el espacio
				</ParagraphSection>
				<Column marginTop="20px">
					{universityActivityListSegmented.sport.length > 0 &&
						<HandlerCheckbox
							description="Actividades deportivas"
							checkboxProps={universityActivityListSegmented.sport.map(getCheckboxProps)}
							onChange={newAvailableActivityIds.toggleAvailableActivity} />}
					<HandlerCheckbox
						description="Actividades no deportivas"
						checkboxProps={universityActivityListSegmented.nonSport.map(getCheckboxProps)}
						onChange={newAvailableActivityIds.toggleAvailableActivity} />
				</Column>
				<Footer>
					<CustomButton
						size="medium"
						variant="secondary"
						text="Cancelar"
						onClick={dialog.hide} />
					<CustomButton
						size="medium"
						text="Guardar"
						onClick={saveChanges} 
						disabled={newAvailableActivityIds.isEmpty()}/>
				</Footer>
			</Container>
		</DialogAlert>
	);
}

export default AvailableActivitiesFieldModal;